import { createSlice } from '@reduxjs/toolkit';

const OrderSlice = createSlice({
  name: 'OrderSlice',
  initialState: {
    isLoading: false,
    isViewLoading: false,
    orderListData: [],
    isError: null,
    viewOrderDetails: null,
    isSyncLoading: false,
    isDownloadLoading: false,
    isCreditInvoiceDownloadLoading: false,
  },
  reducers: {
    /////// Order list start //////

    requestOrderList: (state) => {
      return { ...state, isLoading: true };
    },
    responseOrderList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        orderListData: action?.payload?.data,
      };
    },
    failureOrderList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    /////// Order Add-Edit //////
    // requestOrderAdd: (state) => {
    //   return { ...state, isLoading: true };
    // },
    // responseOrderAdd: (state, action) => {
    //   return { ...state, isLoading: false };
    // },
    // failureOrderAdd: (state, action) => {
    //   return { ...state, isLoading: false, isError: action?.payload };
    // },

    ////////// Order View /////////
    requestOrderView: (state) => {
      return { ...state, isViewLoading: true };
    },
    responseOrderView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewOrderDetails: action.payload,
      };
    },
    failureOrderView: (state, action) => {
      return { ...state, isViewLoading: false, isError: action?.payload };
    },

    ////// Sync Order Data ////
    requestSyncDataOrder: (state) => {
      return { ...state, isSyncLoading: true };
    },
    responseSyncDataOrder: (state) => {
      return { ...state, isSyncLoading: false };
    },
    failureSyncDataOrder: (state, action) => {
      return { ...state, isSyncLoading: false, isError: action?.payload };
    },

    ///// Download order invoice PDF ////
    requestDownloadOrderPDF: (state) => {
      return { ...state, isDownloadLoading: true };
    },
    responseDownloadOrderPDF: (state) => {
      return { ...state, isDownloadLoading: false };
    },
    failureDownloadOrderPDF: (state, action) => {
      return { ...state, isDownloadLoading: false, isError: action?.payload };
    },

    requestCreditInvoiceDownload: (state) => {
      return { ...state, isCreditInvoiceDownloadLoading: true };
    },

    responseCreditInvoiceDownload: (state) => {
      return { ...state, isCreditInvoiceDownloadLoading: false };
    },

    failureCreditInvoiceDownload: (state, action) => {
      return {
        ...state,
        isCreditInvoiceDownloadLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  failureOrderList,
  requestOrderList,
  responseOrderList,
  failureOrderView,
  requestOrderView,
  responseOrderView,
  failureSyncDataOrder,
  requestSyncDataOrder,
  responseSyncDataOrder,
  requestDownloadOrderPDF,
  responseDownloadOrderPDF,
  failureDownloadOrderPDF,
  requestCreditInvoiceDownload,
  responseCreditInvoiceDownload,
  failureCreditInvoiceDownload,
} = OrderSlice.actions;
export default OrderSlice.reducer;
